import confetti from 'canvas-confetti';

export function playCelebrationChime() {
  try {
    const AudioContextClass = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    if (!AudioContextClass) return;
    const ctx = new AudioContextClass();
    const notes = [523.25, 659.25, 783.99, 1046.50]; // C5, E5, G5, C6 (sparkle arpeggio)
    notes.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      const startTime = ctx.currentTime + i * 0.08;
      osc.frequency.setValueAtTime(freq, startTime);
      gain.gain.setValueAtTime(0.2, startTime);
      gain.gain.exponentialRampToValueAtTime(0.001, startTime + 0.35);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(startTime);
      osc.stop(startTime + 0.35);
    });
  } catch {
    // AudioContext might be silent if muted
  }
}

export function playMasteryFanfare() {
  try {
    const AudioContextClass = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    if (!AudioContextClass) return;
    const ctx = new AudioContextClass();
    // Victory fanfare: G4, C5, E5, G5
    const chord = [392.00, 523.25, 659.25, 783.99, 1046.50];
    chord.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'triangle';
      const startTime = ctx.currentTime + i * 0.1;
      osc.frequency.setValueAtTime(freq, startTime);
      gain.gain.setValueAtTime(0.25, startTime);
      gain.gain.exponentialRampToValueAtTime(0.001, startTime + 0.6);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(startTime);
      osc.stop(startTime + 0.6);
    });
  } catch {
    // ignore
  }
}

export const fireStepConfetti = fireFullScreenStepConfetti;

export function fireFullScreenStepConfetti(onComplete?: () => void) {
  playCelebrationChime();
  const duration = 1400;
  const animationEnd = Date.now() + duration;

  // Massive screen-wide burst from center
  confetti({
    particleCount: 120,
    spread: 120,
    origin: { x: 0.5, y: 0.4 },
    colors: ['#FF69B4', '#40E0D0', '#FFD700', '#00BFFF', '#98FB98', '#9370DB', '#FF7F50'],
    disableForReducedMotion: true,
  });

  // Streaming side cannons covering top, left, right
  const frame = () => {
    confetti({
      particleCount: 8,
      angle: 60,
      spread: 75,
      origin: { x: 0, y: 0.6 },
      colors: ['#40E0D0', '#FFD700', '#FF69B4'],
    });
    confetti({
      particleCount: 8,
      angle: 120,
      spread: 75,
      origin: { x: 1, y: 0.6 },
      colors: ['#00BFFF', '#98FB98', '#9370DB'],
    });

    if (Date.now() < animationEnd) {
      requestAnimationFrame(frame);
    } else if (onComplete) {
      onComplete();
    }
  };
  frame();
}

export function fireMasteryConfetti(onComplete?: () => void) {
  playMasteryFanfare();
  const duration = 3000;
  const animationEnd = Date.now() + duration;

  const frame = () => {
    confetti({
      particleCount: 12,
      angle: 60,
      spread: 90,
      origin: { x: 0, y: 0.7 },
      colors: ['#FF69B4', '#FFD700', '#40E0D0'],
    });
    confetti({
      particleCount: 12,
      angle: 120,
      spread: 90,
      origin: { x: 1, y: 0.7 },
      colors: ['#00BFFF', '#98FB98', '#FF7F50'],
    });

    if (Date.now() < animationEnd) {
      requestAnimationFrame(frame);
    } else if (onComplete) {
      onComplete();
    }
  };
  frame();
}
